import { FC } from 'react';
import { Badge, BADGE_VARIANTS } from 'ui/badge';
import { FlagIcon } from 'ui/flags';
import { findCountryCode } from 'modules/templateEditor/common/LocaleLabel/LocaleLabel';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { ProjectLocales } from './LocalesTable';

const Wrapper = styled.div`
display:flex;
align-items: center;
gap: ${spacing.half};
`;

export const LocaleTableCell: FC<{ row: ProjectLocales }> = ({ row }) => {
  return (
    <Wrapper>
      <FlagIcon code={findCountryCode(row.locale)} /> {row.locale}
      {row.isDefault && (
        <Badge variant={BADGE_VARIANTS.POSITIVE} icon={<></>}>
          default
        </Badge>
      )}
    </Wrapper>
  );
};
